import { Pagination } from './pagination';

export class FilterQuery {
  paginationDto: Pagination;
  filterDto: any;

}
